/**
 * Owner: Masa Bayu
 * File: responsive-band.ts
 * Date:Time: 2026-09-15 20:00
 * Description: QXRead responsive breakpoint band resolver for Gate T0 evidence.
 */

import { QXREAD_BREAKPOINT_BANDS, type QxreadBreakpointBand } from '@qx/qxread-core';

/** Width floors (px) — §373 QX Responsive UI Standard zones: mobile <768 · tablet 768–1023 · desktop ≥1024. */
export const QXREAD_BREAKPOINT_MIN_WIDTH = Object.freeze({
  mobile: 0,
  tablet: 768,
  desktop: 1024,
} as const satisfies Record<QxreadBreakpointBand, number>);

export function resolveQxreadBreakpointBand(widthPx: number): QxreadBreakpointBand {
  if (!Number.isFinite(widthPx) || widthPx < 0) {
    throw new Error('QXRead breakpoint width must be a non-negative finite number');
  }
  let resolved: QxreadBreakpointBand = 'mobile';
  for (const band of QXREAD_BREAKPOINT_BANDS) {
    const min = QXREAD_BREAKPOINT_MIN_WIDTH[band];
    if (widthPx >= min) {
      resolved = band;
    }
  }
  return resolved;
}
